
import { createSlice } from '@reduxjs/toolkit';

export const tenaSlice = createSlice({
    name:'TENANT',
    initialState:{
        loading: false,
        data: {

        },
        error: false,
    },
    reducers:{
        TENANT_FETCH_START:(state)=>{
            state.loading=true
        },
        TENANT_FETCH_SUCCESS:(state,action)=>{
            state.loading=false
            state.data=action.payload
        },
        TENANT_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const { TENANT_FETCH_START,TENANT_FETCH_SUCCESS,TENANT_FETCH_ERROR }=tenaSlice.actions;
export default tenaSlice.reducer;